<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> {{ $class() }} </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'lodType'" [label]="'LOD Type'" [selectionPossibilities]="$lodTypePossibilites()"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
